import { Component, OnInit } from '@angular/core';

@Component({
    templateUrl: './baking.component.html',
    styleUrls: ['./baking.component.css'],
})

export class BakingComponent implements OnInit {
  constructor(
  ) {}

  ngOnInit() {
  }
}
